<div class="container-fluid">
    <div class="row">
      <div
        class="col-12 col-sm-5 d-none d-sm-flex flex-column min-full-height justify-content-between left-panel position-relative"
      >
        <img
          src="../../../assets/images/Logo-colorido.png"
          alt="Logo"
          class="logo"
        />
        <p class="bottom-text">
          Avoid The Headache, Get a Simple Solution That Meets Your Needs
        </p>
      </div>
      <div class="col-12 d-sm-none pt-5 px-4">
        <img
          src="../../../assets/images/Logo-colorido.png"
          alt="Logo"
          class="logo"
        />
      </div>
      <div class="col-12 col-sm-7">
        <div class="right-panel">
          <form (ngSubmit)="onSubmit()" class="login-form">
            <p class="title">Create New Password</p>
            <div class="form-group">
                <label for="password" class="input-label" autocomplete="new-password">Password</label>
                <div class="input-group">
                  <span class="input-group-text" id="basic-addon1">
                    <i class="bi bi-lock"></i>
                  </span>
                  <input
                    type="{{ showPassword ? 'text' : 'password' }}"
                    class="form-control input-label"
                    [(ngModel)]="usrPassword"
                    name="password"
                    #passwordInput
                    (input)="checkFields()"
                    (focus)="onInputFocus()"
                    (keyup)="validatePassword(usrPassword)"
                  />
                  <div class="input-group-append" *ngIf="usrPassword">
                    <span
                      class="input-group-text span-eye"
                      (click)="togglePasswordVisibility(passwordInput)"
                    >
                      <i
                        class="bi bi-eye"
                        [ngClass]="{
                          'bi-eye-slash': showPassword,
                          'bi-eye': !showPassword,
                          'eye-slash-color': showPassword
                        }"
                        class="eye-icon"
                        (mouseover)="addHoverClass()"
                        (mouseout)="removeHoverClass()"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="password-validation text-left">
                        <div>
                            <i [ngClass]="{ 'bi bi-x-lg text-danger': !isLengthValid, 'bi bi-check-lg text-success': isLengthValid } " style="margin-right: 5px;"></i>
                            {{ isLengthValid ? 'Meets length requirement' : 'Must be at least 8 characters' }}
                        </div>
                        <div>
                            <i [ngClass]="{ 'bi bi-x-lg text-danger': !hasNumber, 'bi bi-check-lg text-success': hasNumber }" style="margin-right: 5px;"></i>
                            {{ hasNumber ? 'Contains a number' : 'Must contain at least 1 number' }}
                        </div>
                        <div>
                            <i [ngClass]="{ 'bi bi-x-lg text-danger': !hasCapitalCase, 'bi bi-check-lg text-success': hasCapitalCase }" style="margin-right: 5px;"></i>
                            {{ hasCapitalCase ? 'Contains a capital letter' : 'Must contain at least 1 capital letter' }}
                        </div>
                        <div>
                            <i [ngClass]="{ 'bi bi-x-lg text-danger': !hasSmallCase, 'bi bi-check-lg text-success': hasSmallCase }" style="margin-right: 5px;"></i>
                            {{ hasSmallCase ? 'Contains a lowercase letter' : 'Must contain at least 1 lowercase letter' }}
                        </div>
                        <div>
                            <i [ngClass]="{ 'bi bi-x-lg text-danger': !hasSpecialChar, 'bi-check-lg text-success': hasSpecialChar }" style="margin-right: 5px;"></i>
                            {{ hasSpecialChar ? 'Contains a special character' : 'Must contain at least 1 special character' }}
                        </div>
            </div>
            <div class="form-group mt-3">
              <label for="confirmPassword" class="input-label" autocomplete="new-password">Confirm Password</label>
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1">
                  <i class="bi bi-lock"></i>
                </span>
                <input
                  type="{{ showConfirmPassword ? 'text' : 'password' }}"
                  class="form-control input-label"
                  [(ngModel)]="confirmPassword"
                  name="password"
                  #passwordInputConfirm
                  (input)="checkFields()"
                  (focus)="onInputFocus()"
                />
                <div class="input-group-append" *ngIf="confirmPassword">
                  <span
                    class="input-group-text span-eye"
                    (click)="toggleConfirmPasswordVisibility(passwordInputConfirm)"
                  >
                    <i
                      class="bi bi-eye"
                      [ngClass]="{
                        'bi-eye-slash': showConfirmPassword,
                        'bi-eye': !showConfirmPassword,
                        'eye-slash-color': showConfirmPassword
                      }"
                      class="eye-icon"
                      (mouseover)="addHoverClass2()"
                      (mouseout)="removeHoverClass2()"
                    ></i>
                  </span>
                </div>
              </div>
            </div>
            <div>
                <i [ngClass]="{ 'bi bi-x-lg text-danger': !passwordsMatch, 'bi-check-lg text-success': passwordsMatch }" style="margin-right: 5px;"></i>
                {{ passwordsMatch ? 'Password Match' : 'Password does not match' }}
            </div>
            <div class="form-group div-Forgot">
              <a [routerLink]="['/login']" class="forgot-password" (click)="returnToLogin()">Sign in</a>
            </div>
            <div class="form-group mt-3">
              <button
                type="submit"
                class="sign-in-button btn btn-primary"
                [disabled]="!fieldsCompleted"
              >
                Save my new password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  